import { get } from "../methods";
function getGridView(id) {
  return get({
    url: `api/grid/view/${id}`
  });
}
export {
  getGridView as default
};
